<app-breadcrumb *ngIf="!disableBreadcrumb" [master]="'Newsletter'" [parentName]="newsletterObject?.newsletterName ? newsletterObject?.newsletterName : 'Newsletter'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-newsletter-details-view [newsletter]="newsletter" *ngIf="!modify" (modifyClicked)="modify = true"></app-newsletter-details-view>
    <app-newsletter-add *ngIf="modify" [newsletter]="newsletter" (closeModification)="modify = false; loadNewsletter()"></app-newsletter-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [newsletter]="newsletter"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
